function pillarsBlock() {
	const sections = document.querySelectorAll('[data-block="pillars-block"]');
	
	sections.forEach((section, sIndex) => {
		const pillars = section.querySelectorAll('[data-name="pillar-block"]');
		
		if (!pillars.length || window.innerWidth < 768) return;
		
		let maxHeight = 0;
		let maxTextHeight = 0;
		const containers = [];
		
		pillars.forEach((pillar, pIndex) => {
			const container = pillar.querySelector('.group');
			const text = container.querySelector('p');
			if (container) {
				containers.push(container);
				container.style.height = 'auto';
				const height = container.offsetHeight;
				maxHeight = Math.max(maxHeight, height);
				
				if (text) {
					const clone = text.cloneNode(true);
					// Use parent container width
					const parentWidth = container.clientWidth - 50; 
					clone.style.cssText = `height:auto; display:block; visibility:hidden; position:absolute; width:${parentWidth}px;`;
					text.parentNode.appendChild(clone);
					const textHeight = clone.scrollHeight;
					maxTextHeight = Math.max(maxTextHeight, textHeight);
					text.parentNode.removeChild(clone);
				}
			}
		});
		
		containers.forEach(container => {
			container.style.height = `${maxHeight}px`;
		});
		
		const growthMargin = (maxTextHeight + 30) / 2;
		section.style.marginTop = `${growthMargin}px`;
		section.style.marginBottom = `${growthMargin}px`;
		
		pillars.forEach(pillar => {
			const container = pillar.querySelector('.group');
			const text = container.querySelector('p');
			
			if (!text || !container) return;
			
			pillar.style.position = 'relative';
			container.style.position = 'absolute';
			container.style.top = '0';
			container.style.left = '0';
			container.style.right = '0';
			container.style.zIndex = '1';
			pillar.style.height = `${maxHeight}px`;
			
			const enterHandler = () => {
				if (window.innerWidth < 1280) {
					pillars.forEach(otherPillar => {
						if (otherPillar !== pillar) {
							otherPillar.style.opacity = '0.5';
							otherPillar.style.transition = 'opacity 0.3s ease';
						}
					});
				}
				
				text.style.height = 'auto';
				const textHeight = text.scrollHeight;
				text.style.height = '0';
				text.style.opacity = '1';
				text.style.marginTop = '20px';
				text.style.transition = 'all 0.3s ease';
				
				container.style.zIndex = '50';
				
				const newHeight = maxHeight + textHeight + 20;
				container.style.height = `${newHeight}px`;
				container.style.transition = 'all 0.3s ease';
				const shift = (newHeight - maxHeight) / 2;
				container.style.transform = `translateY(-${shift}px)`;
				
				const contentDiv = container.querySelector('div');
				if (contentDiv) {
					contentDiv.style.transform = `translateY(-${(textHeight + 20) / 2}px)`;
					contentDiv.style.transition = 'transform 0.3s ease';
				}
			};
			
			const leaveHandler = () => {
				if (window.innerWidth < 1280) {
					pillars.forEach(otherPillar => {
						otherPillar.style.opacity = '1';
					});
				}
				
				text.style.transition = 'all 0.15s ease';
				text.style.height = '0';
				text.style.marginTop = '0';
				text.style.opacity = '0';
				
				container.style.transition = 'all 0.25s ease';
				container.style.height = `${maxHeight}px`;
				container.style.transform = 'translateY(0)';
				container.style.zIndex = '1';
				const contentDiv = container.querySelector('div');
				if (contentDiv) {
					contentDiv.style.transition = 'transform 0.25s ease';
					contentDiv.style.transform = 'translateY(0)';
				}
			};
			
			pillar.onmouseenter = enterHandler;
			pillar.onmouseleave = leaveHandler;
			
			pillar.onclick = () => {
				if (window.innerWidth < 1024) { 
					const isExpanded = container.style.zIndex === '50';
					if (isExpanded) leaveHandler();
					else enterHandler();
				}
			};
		});
	});
}

function pillarsAnimation(){
    pillarsBlock();

    let resizeTimer;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
            if (document.querySelector('[data-block="pillars-block"]')) {
                pillarsBlock();
            }
        }, 500);
    });
}

export default pillarsAnimation;